export default class ListaActivateIds {
    constructor(listaIds) {
        this.idsToActivate = listaIds 
    }
    static create(listaIds) {
        return new ListaActivateIds(listaIds)
    }
}